import locations from './pages/routes/locations';
import Router from './pages/utils/Router';

const routes = new Router({
	locations,
});

// Load Events
routes.loadEvents();
